import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const STORAGE_KEY = 'oh:recently-viewed:v2';
const MAX_DISPLAY = 8;

export function trackRecentlyViewed(product) {
  if (!product?.id) return;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    let list = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(list)) list = [];
    list = list.filter((p) => String(p?.id) !== String(product.id));
    list.unshift({
      id: product.id,
      name: product.name,
      price: product.price,
      image: product?.images?.[0]?.url || product?.images?.[0]?.src || product?.image || '',
      rating: Number(product.rating) || 0,
    });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, 12)));
  } catch {}
}

const renderStars = (rating) => {
  const stars = [];
  const full = Math.floor(rating);
  const half = rating % 1 !== 0;
  for (let i = 0; i < full; i++) {
    stars.push(<Icon key={i} name="Star" size={12} className="text-warning fill-current" />);
  }
  if (half) stars.push(<Icon key="half" name="StarHalf" size={12} className="text-warning fill-current" />);
  for (let i = 0; i < 5 - Math.ceil(rating); i++) {
    stars.push(<Icon key={`e-${i}`} name="Star" size={12} className="text-muted-foreground" />);
  }
  return stars;
};

const RecentlyViewed = ({ currentProductId }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const list = raw ? JSON.parse(raw) : [];
      if (Array.isArray(list)) {
        setItems(
          list
            // Defensive: drop entries lacking a numeric id (broken trackings).
            // A card with no id would link to ?id=undefined and produce a
            // blank product page on click — looks like "nothing happens".
            .filter((p) => p?.id != null && String(p.id) !== String(currentProductId))
            .slice(0, MAX_DISPLAY)
        );
      }
    } catch {}
  }, [currentProductId]);

  if (items.length === 0) return null;

  return (
    <section>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-heading font-semibold text-foreground">Recently Viewed</h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {items.map((p) => (
          <Link
            key={p.id}
            to={`/product-details?id=${p.id}`}
            className="group bg-card border border-border rounded-lg overflow-hidden hover:shadow-elevation-2 transition-all"
          >
            <div className="aspect-square overflow-hidden bg-muted">
              <Image
                src={p.image}
                alt={p.name}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="p-3">
              <h3 className="text-sm font-medium text-foreground line-clamp-2 mb-1 min-h-[2.5rem]">
                {p.name}
              </h3>
              {p.rating > 0 && (
                <div className="flex items-center gap-0.5 mb-1">
                  {renderStars(p.rating)}
                </div>
              )}
              <p className="text-sm font-semibold text-foreground">
                ${(Number(p.price) || 0).toFixed(2)}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RecentlyViewed;
